import { render } from "./kalio-investor-card.vue?vue&type=template&id=de4a1858"
import script from "./kalio-investor-card.vue?vue&type=script&lang=js"
export * from "./kalio-investor-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__